const normalize = str => {
  if (!str) {
    return str
  }
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const removeNonAlphanumeric = str => {
  return str.replace(/[^A-Z0-9]/gi, '')
}

const areStringContained = (a, b) => {
  return normalize(a).toLowerCase().includes(normalize(b).toLowerCase())
}

const compareStrings = (a, b) => {
  return normalize(a).toLowerCase().localeCompare(normalize(b).toLowerCase())
}

export {
  normalize,
  removeNonAlphanumeric,
  areStringContained,
  compareStrings
}



// WEBPACK FOOTER //
// ./client/utils/stringUtils.js